export default __webpack_public_path__ + "static/media/josef-beuys.85f1a350.jpg";